import { type Dispatch } from "@reduxjs/toolkit";
import assessmentsDataService from "../../services/assessmentsDataService";
import { fetchBegin, fetchSuccess, fetchFailure } from "../slices/assessmentUsersSlice";
import { type GetContentUsersParams, v2FilterMap } from "../../../../People/types";
import userListUtils from "../../../../../utils/userListUtils";
import { escapeTerm } from "../../../../../utils/searchUtils";
import { formatFiltersV2api, mapToV2Filters } from "../../../../../utils/queryUtils";

const countHeaderName = process.env.REACT_APP_COUNT_HEADER_NAME as string;

export const fetchAssessmentUsers =
  ({ entityId, skip, top, sortingColumn, sortingDirection, filter, term }: GetContentUsersParams) =>
  async (dispatch: Dispatch) => {
    dispatch(fetchBegin());
    try {
      const filters = formatFiltersV2api(mapToV2Filters(filter, v2FilterMap));
      const searchTerm = escapeTerm(term);
      const request = { skip, top, sortBy: sortingColumn, sortOrder: sortingDirection, term: searchTerm, ...filters };
      const { data, headers } = await assessmentsDataService.getAssessmentUsersV2Async(entityId, request);
      dispatch(
        fetchSuccess({ items: userListUtils.mapToContentUsers(data), totalCount: Number(headers[countHeaderName]) }),
      );
    } catch (e) {
      dispatch(fetchFailure(e as Error));
    }
  };
